import {
  ConsultationSession,
  ConversationDirection,
  InitialModality,
  ChatChannelType,
  IServiceInformation,
  ConversationOriginType,
} from '@nimbus-library/features/shared/models/participant-info/i-combined-conversation.response';
import { CallerType } from '@nimbus-library/features/shared/models/enum/caller-type.enum';
import { ConversationTaskType } from '@nimbus-global/features/reportingLiveData/models/task-type.enum';
import { ICallerParameters, IServiceParameters } from './session-parameters.model';

export enum UserSessionState {
  Selected = 'Selected',
  DialingOut = 'DialingOut',
  Ongoing = 'Ongoing',
  Transferring = 'Transferring',
  Parked = 'Parked',
  PutOnHold = 'PutOnHold',
  InAfterCallWork = 'InAfterCallWork',
  InExtendedAfterCallWork = 'InExtendedAfterCallWork',
  Terminated = 'Terminated',
}

export enum UserSessionOutcome {
  Accepted = 'Accepted',
  Declined = 'Declined',
  Rona = 'Rona',
  Canceled = 'Canceled',
  DestinationAccepted = 'DestinationAccepted',
  DestinationDeclined = 'DestinationDeclined',
  DestinationNotReached = 'DestinationNotReached',
  OutboundUserNotAccepted = 'OutboundUserNotAccepted',
  OutboundUserAborted = 'OutboundUserAborted',
  Failed = 'Failed',
  MarkedAsHandledByUser = 'MarkedAsHandledByUser',
  ConsultedTransferred = 'ConsultedTransferred',
  TransferredInternally = 'TransferredInternally',
  TransferredExternally = 'TransferredExternally',
  InternalTransferFailed = 'InternalTransferFailed',
  ExternalTransferFailed = 'ExternalTransferFailed',
}

export interface IUserSessionBase {
  id: string;
  conversationId: string;
  unifiedConversationId: string;
  teamId: string;
  teamInformation?: IServiceInformation;
  initialModality: InitialModality;
  originType: ConversationOriginType;
  channel: ChatChannelType;
  callDirection: ConversationDirection;
  callerId: {
    id: string;
    type: CallerType;
  };
  state: UserSessionState;
  outcome: UserSessionOutcome;
  since: string;
  startedAt: string;
  enteredQueueAt: string;
  acceptedAt: string;
  unparkRequestedAt: string;
  callerHungUpAt?: string;
  transferStartedAt?: string;
  transferCompletedAt?: string;
  conversationTerminatedAt: string;
  timestamp?: string;
  timeRinging: string;
  timeInQueue: string;
  timeConnected: string;
  areAttributesSubmitted?: boolean;
  taskType: ConversationTaskType;
}

export interface IUserSessionHistorical extends IUserSessionBase {
  customerIdentifier: string;
  serviceInformation: IServiceParameters;
  callInformation: ICallerParameters;
  codesAndTagsWidgetEnabled: boolean;
  startedWithTransfer?: boolean;
  acceptedByOtherUserId?: string;
  acceptedByOtherUserDisplayName?: string;
}

export interface IUserSessionLive extends IUserSessionBase {
  callerParameters: ICallerParameters;
  serviceParameters: IServiceParameters;
  afterCallWorkDuration: string;
  afterCallWorkAllowToStop: boolean;
  afterCallWorkAllowToExtend: boolean;
  isSupervisionSessionInProgress: boolean;
  consultationSession: ConsultationSession;
  orderNumber: number;
  imHasNewMessages?: boolean;
  startedWithTransfer?: boolean;
}
